import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import https from "https-browserify";

const TokenContext = createContext();

export const useToken = () => useContext(TokenContext);

export const TokenProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [usuarioData, setUsuarioData] = useState({});
  const [loading, setLoading] = useState(true);
  // Full API base URL (scheme + host + optional port).
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const savedUser = localStorage.getItem("user");

    if (savedUser) {
      const user = JSON.parse(savedUser);
      setToken(user.token);
      setUsuarioData(user.user);
      axios
        .get(`${apiBaseUrl}/users/${user.user.id}`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          httpsAgent: new https.Agent({
            rejectUnauthorized: false,
          }),
        })
        .then((response) => {
          const perms =
            response?.data?.data?.role?.permissions ??
            response?.data?.permissions ??
            [];
          setPermissions(Array.isArray(perms) ? perms : []);
        })
        .catch((err) => {
          console.error("Erro ao buscar usuário/permissions:", err);
          // 401 = token expirado (spec 015): sinaliza re-login.
          if (err?.response?.status === 401) {
            try {
              sessionStorage.setItem("sessionExpired", "1");
            } catch {
              /* storage indisponível */
            }
          }
          localStorage.removeItem("user");
          window.location.reload();
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const updateToken = (newToken, newPermissions, newUser) => {
    const userData = {
      token: newToken,
      user: newUser,
    };

    if (userData.user?.role && userData.user.role.permissions) {
      const roleCopy = { ...userData.user.role };
      delete roleCopy.permissions;
      userData.user = { ...userData.user, role: roleCopy };
    }

    localStorage.setItem("user", JSON.stringify(userData));

    setToken(newToken);
    setPermissions(Array.isArray(newPermissions) ? newPermissions : []);
    setUsuarioData(newUser);
  };

  const hasPermission = (slugPermission) => {
    /* istanbul ignore next -- defensive: permissions state is always an array (setPermissions/updateToken coerce non-arrays to []) */
    if (!permissions || !Array.isArray(permissions)) return false;
    const found = permissions.find((p) => p.slug === slugPermission);
    return !!found;
  };

  return (
    <TokenContext.Provider
      value={{
        token,
        permissions,
        updateToken,
        hasPermission,
        loading,
        usuarioData,
      }}
    >
      {children}
    </TokenContext.Provider>
  );
};

TokenProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
